import firebase from '../../../../../../firebase';
import { validateField } from './validators';
import { openSnackbar } from '../../../../../../app/modules/snackbar/actions';

const newGroupFieldChange = (prop, value, isValid) => ({
  type: 'NEW_FIELD_CHANGE',
  prop,
  value,
  isValid,
});

export const openFieldDialog = () => ({
  type: 'OPEN_FIELD_DIALOG',
});

export const closeFieldDialog = () => ({
  type: 'CLOSE_FIELD_DIALOG',
});

export const updateToggleField = (appname, toggled, field) => dispatch =>
  firebase
    .database()
    .ref(`app_groups/${appname}/groups/default`)
    .update({ [`${field}`]: toggled })
    .then(() =>
      dispatch({
        type: 'TOGGLE_FIELD',
        appname,
        field,
        toggled,
      }),
    );

export const updateCustomToggleField = (
  appname,
  toggled,
  field,
  key,
) => dispatch =>
  firebase
    .database()
    .ref(
      `app_groups/${appname}/groups/default/customProfileFields/${key}/${field}`,
    )
    .update({ value: toggled });

export const handleDelete = (appname, key) => dispatch =>
  firebase
    .database()
    .ref(`app_groups/${appname}/groups/default/customProfileFields/${key}`)
    .set(null)
    .then(() => dispatch(openSnackbar('Field Deleted')));

export const handleCustomFieldClick = (key, index) => dispatch => {
  return dispatch({ type: 'CUSTOM_FIELD_CLICK', key, index });
};

export const formFieldChange = (prop, value) => dispatch => {
  const isValid = value.length > 0 ? validateField[prop](value) : null;

  return dispatch(newGroupFieldChange(prop, value, isValid));
};

export const addField = appname => (dispatch, getState) => {
  const {
    name,
    type,
    options,
    visibleToGroups,
    isMultiple,
    isRequired,
    isVisible,
  } = getState().auth.settings.profileFields.userProfileField;

  const field = {
    name: { value: name.value, isValid: true },
    options: { value: options.value, isValid: true },
    type: { value: type.value, isValid: true },
    visibleToGroups: { value: visibleToGroups.value, isValid: true },
    isRequired: { value: isRequired.value },
    isMultiple: { value: isMultiple.value },
    isVisible: { value: isVisible.value },
    createdAt: Date.now(),
  };

  dispatch({ type: 'ADD_UPDATE_FIELD' });
  return firebase
    .database()
    .ref(`app_groups/${appname}/groups/default/customProfileFields`)
    .push(field)
    .then(ref => {
      dispatch({
        type: 'NEW_FIELD_ADDED',
        key: ref.key,
        data: field,
      });
      dispatch(openSnackbar('Field Created'));
    });
};

export const updateCustomField = (appname, key) => (dispatch, getState) => {
  const {
    name,
    type,
    options,
    isMultiple,
    isRequired,
    isVisible,
    visibleToGroups,
  } = getState().auth.settings.profileFields.userProfileField;

  const field = {
    name: { value: name.value, isValid: true },
    options: { value: options.value, isValid: true },
    type: { value: type.value, isValid: true },
    visibleToGroups: { value: visibleToGroups.value, isValid: true },
    isRequired: { value: isRequired.value },
    isMultiple: { value: isMultiple.value },
    isVisible: { value: isVisible.value },
    updatedAt: Date.now(),
  };

  dispatch({ type: 'ADD_UPDATE_FIELD' });
  return firebase
    .database()
    .ref(`app_groups/${appname}/groups/default/customProfileFields/${key}`)
    .update(field)
    .then(ref => {
      dispatch({
        type: 'UPDATE_CUSTOM_FIELD',
        key: key,
        data: field,
      });
      dispatch(openSnackbar('Field Updated'));
    });
};

export const fetchCustomUserProfileField = appname => dispatch => {
  return firebase
    .database()
    .ref(`app_groups/${appname}/groups/default/customProfileFields`)
    .on('value', snapshot => {
      if (snapshot.exists()) {
        dispatch({
          type: 'CUSTOM_PROFILE_FIELDS',
          data: Object.entries(snapshot.val()),
        });
      }
    });
};
